import React from 'react';
import { Link } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import InstallmentPopUp from './InstallmentPopUp';
import SalesOrderAPI from '../../api/SalesOrderAPI';
import RoomAPI from '../../api/RoomAPI';
import PropertyAPI from '../../api/PropertyAPI';
import ApiUiController from '../../controller/ApiUiController';
import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import Display from '../../util/Display';
import Util from '../../util/Util';
import Papa from 'papaparse';
import moment from 'moment';
import { AiOutlineFilePdf } from "react-icons/ai";
import { 
  Container, 
  Row, 
  Col, 
  Card, 
  Button, 
  Dropdown, 
} from 'react-bootstrap';
import { FaEnvelope, FaFileCsv } from "react-icons/fa";
import { FcViewDetails } from "react-icons/fc";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FaCreditCard } from "react-icons/fa6";
import SalesOrderDetails from './SalesOrderDetails';
import SaleInstallmentList from './SaleInstallmentList';
import EmailPopup from '../email/EmailPopupNew';

class BookingPreviewDesign2 extends React.Component {
  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.products = reactLocalStorage.getObject(Const.Products);
    this.models = reactLocalStorage.getObject(Const.Model);
    this.model = this.models.sales_order;
    this.property = this.models.property;
    this.lead = this.models.lead;
    this.users = this.models.user.options;
    this.source = this.models.source.options;
    this.currency = this.models.currency.options;
    this.units = this.models.unit_measure.options;
    this.project = this.models.project.options;
    this.property_type = this.models.sales_order.fields.property_type.options;
    this.sales_type = this.models.sales_order.fields.sales_type.options;
    this.state = { 
      inApiCall: true, 
      popup: false, 
      installment: null, 
      designView: reactLocalStorage.get("booking_design") || "2",
      popupData: null
    };
    this.probability = this.models.probability.options;
    this.sale = {};
    this.update = '';
    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
    this.Export = Util.isAllow(this.model.permission, Const.PermExport);
    this.InstallView = Util.isAllow(this.models.sales_order.permission, Const.PermView);
    this.InstallAdd = Util.isAllow(this.models.sales_order.permission, Const.PermAdd);
    this.InstallUpdate = Util.isAllow(this.models.sales_order.permission, Const.PermUpdate);
    this.EmailAdd = Util.isAllow(this.models.email.permission, Const.PermAdd);
  }

  componentDidMount() {
    SalesOrderAPI.get(this.id, this.onReceived, this.onFail);
  }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };

  onReceived = res => {
    this.sale = res;
    this.update = `/sales-order/add-edit/${this.sale.model_no}/${this.sale.model_id}/${this.sale.id}`;
    if (this.sale.project && this.sale.tower && this.sale.room) {
      RoomAPI.getRoom(this.sale.room, this.onRoomReceived, this.onFail);
    } else if (this.sale.property) {
      PropertyAPI.get(this.sale.property, this.onPropertyReceived, this.onFail);
    } else {
      this.setState({ ...this.state, inApiCall: false });
    }
  };

  onRoomReceived = res => {
    if (res.room) {
      this.model.fields.room['options'] = [{ label: res.room.room_name, value: res.room.id }];
    }
    if (res.tower) {
      this.model.fields.tower['options'] = [{ label: res.tower.tower_name, value: res.tower.id }];
    }
    if (res.property) {
      this.model.fields.property['options'] = [{ label: res.property.name, value: res.property.id }];
    }
    this.setState({ ...this.state, inApiCall: false });
  };

  onPropertyReceived = property => {
    this.model.fields.property['options'] = [{ label: property.name, value: property.id }];
    this.setState({ ...this.state, inApiCall: false });
  };

  refresh = () => {
    this.setState({ ...this.state, popup: false, inApiCall: true });
    SalesOrderAPI.get(this.id, this.onReceived, this.onFail);
  };

  setDesign = (designView) => {
    reactLocalStorage.set("booking_design", designView);
    this.setState({ designView }, () => {
      window.location.reload();
    });
  };

  showPopUp = (data, field)  => this.setState({ ...this.state, popupData: data, popup: field });
  hidePopUp = () => this.setState({ ...this.state, popup: false });

  onPreview = () => {
    if (this.sale.model_no === Const.Lead) {
      this.props.navigate(`/lead/preview/${this.sale.model_id}`);
    } else if (this.sale.model_no === Const.Contact) {
      this.props.navigate(`/contact/preview/${this.sale.model_id}`);
    }
  };

  delete = () => {
    Util.confirmAlert('Delete', 'Are you sure you want to delete', 'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      SalesOrderAPI.delete(this.sale.id, this.onDelete, this.onFail);
    });
  };

  onDelete = () => {
    Util.showNotification('Successful', 'Sales Order Deleted successfully', 'success');
    this.props.navigate('/sales-order');
  };

  onExport = () => {
    const data = { ...this.sale };
    Object.keys(data).forEach(key => {
      if (typeof data[key] === 'string' && data[key].indexOf(Const.Opt) !== -1) {
        data[key] = data[key].split(Const.Opt).join('');
      }
      if (data[key] === null || data[key] === '~~' || data[key] === '') {
        data[key] = '-';
      }
    });

    data.source = this.source.find((pro) => pro.value === data?.source)?.label;
    data.probability = this.probability.find((pro) => pro.value === data?.probability)?.label;
    data.currency = this.currency.find((pro) => pro.value === data?.currency)?.label;
    data.responsible_person = this.users.find((pro) => pro.value === data.responsible_person)?.name;
    data.sales_person = this.users.find((pro) => pro.value === data.sales_person)?.name;
    data.project = this.project.find((pro) => pro.value === data.project)?.label;
    data.property = this.project.find((pro) => pro.value === data.property)?.label;
    data.property_type = this.project.find((pro) => pro.value === data.property_type)?.label;
    data.sales_type = this.project.find((pro) => pro.value === data.sales_type)?.label;
    data.start_date = moment(data.start_date).format('YYYY-MM-DD');
    data.end_date = moment(data.end_date).format('YYYY-MM-DD');
    data.created_date = moment(data.created_date).local().format('DD-MM-YYYY HH:mm:ss');
    data.updated_date = moment(data.updated_date).local().format('DD-MM-YYYY HH:mm:ss');
    data.created_by = this.users.find((pro) => pro.value === data.created_by)?.name;
    data.updated_by = this.users.find((pro) => pro.value === data.updated_by)?.name;

    this.generateCSV(data);
  };
  onDownload = () => {
    this.setState({ inApiCall: true });
    SalesOrderAPI.download(this.sale.id, this.onDownaloded, this.onFail);
  };

  onDownaloded = res => {
    window.open(res.link, "_blank");
    this.setState({ inApiCall: false });
  };
  generateCSV = (data) => {
    try {
      const csv = Papa.unparse([data], { header: true });
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'SalesOrder.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      Util.showNotification('Successful', 'Sales Order Data Downloaded successfully', 'success');
    } catch (error) {
      console.error("Error generating CSV:", error);
      Util.showError("Failed to generate CSV file");
    } finally {
      this.setState({ inApiCall: false });
    }
  };

  formatCurrency = (amount) => {
    if (!amount) return '₹0';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  render() {
    const { designView, inApiCall, popup, installment } = this.state;
    const isCompleted = this.sale && this.sale.probability === 1;
    return (
      <ApiUiController inApiCall={inApiCall}>
        <InstallmentPopUp
          show={popup === Const.Installment}
          hide={this.hidePopUp}
          sale={this.sale}
          installment={installment}
          reload={this.refresh}
        />

        { this.EmailAdd ? 
          <EmailPopup
            show={popup === Const.Email}
            onHide={this.hidePopUp}
            data={{
              ...this.sale,
              ...( this.state.popupData ? { installment_id: this.state.popupData?.id } : {} )
            }}
            model={null}
            reload={this.refresh}
            model_no={null}
            model_id={null}
          /> : null
        }

        <div style={{ 
          backgroundColor: "#f8f9fa", 
          minHeight: "100vh", 
          padding: "20px 0",
          fontFamily: "'Inter', sans-serif" 
        }}>
          <Container fluid>
            {/* Header Section */}
            <div style={{
              backgroundColor: "white",
              borderRadius: "12px",
              padding: "20px 24px",
              marginBottom: "24px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              border: "1px solid #e2e8f0"
            }}>
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "12px"
              }}>
                
                {/* Left: Title Section */}
                <div>
                  <h2 style={{ 
                    margin: "0 0 4px 0", 
                    fontWeight: "bold",
                    color: "#1e293b",
                    fontSize: "24px"
                  }}>
                    {Display.FieldValue(this.sale, "model", this.model.fields) || "Booking"}
                  </h2>
                  <p style={{ 
                    margin: "0",
                    color: "#6c757d",
                    fontSize: "14px"
                  }}>
                    Booking Details
                  </p>
                </div>

                {/* Right: Actions Section */}
              <div style={{
                display: "flex",
                gap: "8px",
                flexWrap: "wrap",
                alignItems: "center"
              }}>

                {/* Design Dropdown */}
                <Dropdown style={{ display: "inline-block", marginRight: "8px" }}>
                  <Dropdown.Toggle
                    size="sm"
                    style={{
                      backgroundColor: "#b83078",
                      border: "none",
                      borderRadius: "6px",
                      fontSize: "14px",
                      fontWeight: "600",
                      padding: "6px 12px"
                    }}
                  >
                    Design {designView}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => this.setDesign("1")}>Design 1</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.setDesign("2")}>Design 2</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                {/* Export */}
                {this.Export ? (
                  <Button
                    size="sm"
                    onClick={this.onExport}
                    onMouseEnter={e => {
                      e.currentTarget.style.backgroundColor = "#1D6F42";
                      e.currentTarget.style.color = "#fff";
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "#1D6F42";
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      backgroundColor: "transparent",
                      border: "1px solid #1D6F42",
                      color: "#1D6F42",
                      transition: "all .25s ease"
                    }}
                  >
                    <FaFileCsv />&nbsp;Export
                  </Button>
                ) : null}

                {/* View Lead */}
                <Button
                  size="sm"
                  onClick={this.onPreview}
                  onMouseEnter={e => {
                    e.currentTarget.style.backgroundColor = "#0d6efd";
                    e.currentTarget.style.color = "#fff";
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#0d6efd";
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontWeight: "600",
                    fontSize: "14px",
                    padding: "6px 12px",
                    borderRadius: "6px",
                    backgroundColor: "transparent",
                    border: "1px solid #0d6efd",
                    color: "#0d6efd",
                    transition: "all .25s ease"
                  }}
                >
                  <FcViewDetails />&nbsp;Lead Details
                </Button>

                {/* Update */}
                {this.Update ? (
                  <Button
                    size="sm"
                    as={Link}
                    to={this.update}
                    onMouseEnter={e => {
                      e.currentTarget.style.backgroundColor = "#ffc107";
                      e.currentTarget.style.color = "#212529";
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "#ffc107";
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      backgroundColor: "transparent",
                      border: "1px solid #ffc107",
                      color: "#ffc107",
                      transition: "all .25s ease"
                    }}
                  >
                    <FaEdit />&nbsp;Update
                  </Button>
                ) : null}

                {/* Delete */}
                {this.Delete ? (
                  <Button
                    size="sm"
                    onClick={this.delete}
                    onMouseEnter={e => {
                      e.currentTarget.style.backgroundColor = "#dc3545";
                      e.currentTarget.style.color = "#fff";
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "#dc3545";
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      backgroundColor: "transparent",
                      border: "1px solid #dc3545",
                      color: "#dc3545",
                      transition: "all .25s ease"
                    }}
                  >
                    <MdDelete />&nbsp;Delete
                  </Button>
                ) : null}

                {/* Installment */}
                {isCompleted && this.InstallAdd ? (
                  <Button
                    size="sm"
                    onClick={() => this.showPopUp(null, Const.Installment)}
                    onMouseEnter={e => {
                      e.currentTarget.style.backgroundColor = "#7B1FA2";
                      e.currentTarget.style.color = "#fff";
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "#7B1FA2";
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      backgroundColor: "transparent",
                      border: "1px solid #7B1FA2",
                      color: "#7B1FA2",
                      transition: "all .25s ease"
                    }}
                  >
                    <FaCreditCard />&nbsp;Installment
                  </Button>
                ) : null}

                {/* PDF */}
                {this.model.fields?.booking_pdf && this.sale?.booking_pdf ? (
                  <Button
                    size="sm"
                    onClick={this.onDownload}
                    onMouseEnter={e => {
                      e.currentTarget.style.backgroundColor = "#dc3545";
                      e.currentTarget.style.color = "#fff";
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "#dc3545";
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      backgroundColor: "transparent",
                      border: "1px solid #dc3545",
                      color: "#dc3545",
                      transition: "all .25s ease"
                    }}
                  >
                    <AiOutlineFilePdf />&nbsp;Pdf
                  </Button>
                ) : null}

                {/* Email */}
                {this.EmailAdd ? (
                  <Button
                    size="sm"
                    onClick={() => this.showPopUp(null, Const.Email)}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#0d6efd";
                      e.currentTarget.style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                      e.currentTarget.style.color = "#0d6efd";
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "600",
                      fontSize: "14px",
                      padding: "6px 12px",
                      borderRadius: "6px",
                      backgroundColor: "transparent",
                      border: "1px solid #0d6efd",
                      color: "#0d6efd",
                      transition: "all .25s ease",
                    }}
                  >
                    <FaEnvelope />&nbsp;Email
                  </Button>
                ) : null}

              </div>


              </div>
            </div>
            <Row>
              {/* Left Column - Property & Booking Info */}
              <Col lg={9}>
                {/* Property Information Card - MOVED TO TOP */}
          <Card
            style={{
              border: "1px solid #e5e7eb",
              borderRadius: "14px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              marginBottom: "28px",
              overflow: "hidden",
              background: "#ffffff"
            }}
          >
            <Card.Header
              style={{
                backgroundColor: "#f8fafc",
                borderBottom: "1px solid #e2e8f0",
                padding: "20px 28px",
                display: "flex",
                alignItems: "center"
              }}
            >
              <div
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  backgroundColor: "#e0f2fe",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "14px"
                }}
              >
                <span style={{ color: "#0284c7", fontSize: "20px" }}>🏠</span>
              </div>

              <div>
                <h5 style={{ margin: 0, fontWeight: 600, color: "#0f172a", fontSize: "16px" }}>
                  Property / Project Information
                </h5>
                <p style={{ margin: 0, fontSize: "13px", color: "#64748b" }}>
                  Property specifications and details
                </p>
              </div>
            </Card.Header>

            <Card.Body style={{ padding: "28px" }}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: "22px"
                }}
              >
                {/* Fetch sales type */}
                {(() => {
                  const salesType = Display.FieldValue(this.sale, "property_type", this.model.fields);
                  if (salesType === "Project") {
                    return (
                      <>
                        <InfoItem
                          label="Project Name"
                          value={Display.FieldValue(this.sale, "project", this.model.fields)}
                          highlight={true}
                        />
                        <InfoItem
                          label="Tower"
                          value={Display.FieldValue(this.sale, "tower", this.model.fields)}
                          highlight={true}
                        />
                        <InfoItem
                          label="Room / Flat"
                          value={Display.FieldValue(this.sale, "room", this.model.fields)}
                          highlight={true}
                        />
                        <InfoItem
                          label="Property Type"
                          value={Display.FieldValue(this.sale, "property_type", this.model.fields)}
                          highlight={true}
                        />
                      </>
                    );
                  }

                  if (salesType === "Property") {
                    return (
                      <>
                        <InfoItem
                          label="Property Name"
                          value={this.sale.property_name}
                          highlight={true}

                        />
                        <InfoItem
                          label="Configuration"
                          highlight={true}
                          value={Display.FieldValue(
                          { property_type: this.sale.property_configuration },
                          "property_type",
                          this.property.fields
                          
                        )}
                       />
                        <InfoItem
                          label="Residential Type"
                          highlight={true}
                          value={Display.FieldValue(
                          { type: this.sale.property_res },
                          "type",
                          this.property.fields
                        )}
                       />
                      </>
                    );
                  }

                  return null;
                })()}
              </div>
            </Card.Body>
          </Card>


                {/* Booking Information Card - NOW COMES AFTER PROPERTY INFO */}
                <SalesOrderDetails
                  sale={this.sale}
                  model={this.model}
                  designView={2}
                  excludedFields={[
                    "source", "responsible_person","sales_person","updated_by","updated_date",
                    "probability","created_by","created_date","project","property",
                    "property_type","room","sales_type","tower"
                  ]}
                />

                <SaleInstallmentList 
                  sale={this.sale} 
                  edit={this.showPopUp}
                  reload={this.refresh}
                />
              </Col>

              {/* Right Column - Lead & Timeline Info */}
              <Col lg={3}>
                {/* Lead Information Card */}
              <Card 
              className="mb-3" 
              style={{ 
                border: "1px solid #e5e7eb",
                borderRadius: "14px",
                overflow: "hidden",
                boxShadow: "0 3px 10px rgba(0,0,0,0.08)"
              }}
            >
              {/* IMAGE AREA */}
              <div
                style={{
                  position: "relative",
                  height: "220px",
                  background: "#f1f5f9",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                {/* Main Image OR Dummy */}
                <img
                  src={
                    this.sale.property_image ||
                    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjn7mbWlHkzGfpy2lawCw1ugkHUo364wFJNg&s"
                  }
                  alt="Property"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover"
                  }}
                  onError={(e) => {
                    e.target.src =
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjn7mbWlHkzGfpy2lawCw1ugkHUo364wFJNg&s";
                  }}
                />

                {/* Overlay label */}
                <div
                  style={{
                    position: "absolute",
                    bottom: "12px",
                    left: "12px",
                    background: "rgba(0,0,0,0.55)",
                    padding: "6px 10px",
                    borderRadius: "6px"
                  }}
                >
                  <span style={{ color: "white", fontSize: "12px", fontWeight: "500" }}>
                    Preview
                  </span>
                </div>
              </div>

              {/* FOOTER */}
              <Card.Footer
                style={{
                  backgroundColor: "white",
                  borderTop: "1px solid #e9ecef",
                  padding: "14px 18px"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  <small style={{ fontWeight: "600", color: "#495057" }}>
                    Property Image
                  </small>

                  <Button
                    variant="outline-primary"
                    size="sm"
                    style={{
                      fontSize: "11px",
                      padding: "2px 8px",
                      borderRadius: "6px",
                      border: "1px solid #0d6efd33",
                      backgroundColor: "transparent"
                    }}
                    onClick={() =>
                      window.open(
                        this.sale.property_image ||
                          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjn7mbWlHkzGfpy2lawCw1ugkHUo364wFJNg&s",
                        "_blank"
                      )
                    }
                  >
                    View Full
                  </Button>
                </div>
              </Card.Footer>
            </Card>

                <Card className="mb-2">
                  <Card.Header>
                    <h5 className="mb-0 d-flex align-items-center">
                      <span className="me-2">📄</span> Lead Details
                    </h5>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex flex-column">
                      <div className="mb-3">
                        <small style={{ fontSize: 18, fontWeight: 700, color: "#000000" }}>Name</small>
                        <div className="fw-medium">
                         {this.sale.lead_first} {this.sale.lead_midle} {this.sale.lead_last}
                        </div>
                      </div>

                      <div className="mb-3">
                        <small style={{ fontSize: 18, fontWeight: 700, color: "#000000" }}>Phone</small>
                        <div className="fw-medium">
                        {Display.FieldValue({phone: this.sale.lead_phone}, "phone",this.lead.fields)}
                        </div>
                      </div>

                      <div className="mb-3">
                        <small style={{ fontSize: 18, fontWeight: 700, color: "#000000" }}>Email</small>
                        <div className="fw-medium">
                         {Display.FieldValue({email: this.sale.lead_email}, "email",this.lead.fields)}
                        </div>
                      </div>

                      {/* <div className="mb-1">
                        <small style={{ fontSize: 18, fontWeight: 700, color: "#000000" }}>Address</small>
                        <div className="fw-medium">{this.sale.lead_street}{this.sale.lead_street}{this.sale.lead_street}{this.sale.lead_street}</div>
                      </div> */}
                    </div>
                  </Card.Body>
                </Card>

                <Card className="mb-2">
                  <Card.Header>
                    <h5 className="mb-0 d-flex align-items-center">
                      <span className="me-2">📅</span>Timeline
                    </h5>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex flex-column gap-3">
                      <Row>
                        <Col md={6}>
                          <small style={{ fontSize: 18, fontWeight: 700 }}>Created</small>
                          <div className="medium text-dark">
                            {Display.FieldValue(this.sale, 'created_date', this.model.fields)}
                          </div>
                          <div className="medium text-muted">
                            by {Display.FieldValue(this.sale, 'created_by', this.model.fields)}
                          </div>
                        </Col>
                        <Col md={6}>
                          <small style={{ fontSize: 18, fontWeight: 700 }}>Last Updated</small>
                          <div className="medium text-dark">
                            {Display.FieldValue(this.sale, 'updated_date', this.model.fields)}
                          </div>
                          <div className="medium text-muted">
                            by {Display.FieldValue(this.sale, 'updated_by', this.model.fields)}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ApiUiController>
    );
  }
}

// InfoItem Component with inline styles
const InfoItem = ({ label, value, highlight = false }) => (
  <div style={{ display: "flex", flexDirection: "column" }}>
    <span style={{ 
      fontSize: "11px",
      color: "#64748b",
      fontWeight: "500",
      marginBottom: "4px",
      textTransform: "uppercase"
    }}>
      {label}
    </span>
    <span style={{ 
      fontSize: highlight? "18px":"13px",
      color: highlight ? "#000" : "#1e293b",
      fontWeight: highlight ? "700" : "500"
    }}>
      {value || "-"}
    </span>
  </div>
);

export default withRouter(BookingPreviewDesign2);